import { navigate } from '@/utils/NavigationUtils'
import { type ProcessReturnContext, SelfServiceProcess } from '@/types/SelfServiceProcess'

interface ProcessReturnStore {
  getProcessReturnContext: () => ProcessReturnContext | null
  setPreSelectedPolicyIds: (ids: string[] | null) => void
  resetProcessReturnContext: () => void
}

export function navigateBackFromEmailChange(policiesStore: ProcessReturnStore): void {
  const processOrigin = policiesStore.getProcessReturnContext()
  let target = globalThis.ENV_CONFIG?.REDIRECTS.PERSONAL_PROFIL_PAGE

  switch (processOrigin?.process) {
    case SelfServiceProcess.REQUEST_IVK_PAGE:
      target = globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_IVK_PAGE
      policiesStore.setPreSelectedPolicyIds(processOrigin.policyIds)
      break
    case SelfServiceProcess.REQUEST_DIGITALCARD_PAGE:
      target =
        globalThis.ENV_CONFIG?.SERVICE_LINKS.VERTRAGSSERVICES_PAGE
          .REQUEST_DIGITALCARD_PAGE
      policiesStore.setPreSelectedPolicyIds(processOrigin.policyIds)
      break
  }

  policiesStore.resetProcessReturnContext()
  navigate(target)
}
